import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import Loader from '../../loader/loader'
import { Toast } from 'primereact/toast';

import { Dialog } from 'primereact/dialog';
import useToastNotification from '../../../hooks/useToastNotification';
import ReadyCard from '../ready-card/readyCard'
import DesignCard from '../edit-design-card/editDesign'
import { getCity, getProvince, buyCard, UpdateCard } from '../../../utils/api';
import LoaderBtn from '../../loader/loader'
import { Sidebar } from 'primereact/sidebar';
import ArrowDown from '../../../assets/icons/select-arrow-down.svg'
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
function FastLogin({ item, onClose }) {
    const [visible, setVisible] = useState(true);
    const [editSection, setEditSection] = useState(1);

    // مدیریت state برای داده‌های کاربر
    const [userData, setUserData] = useState(null);
    const [designCardData, setDesignCardData] = useState(null);

    const onCloseModal = () => {
        if (onClose) onClose();
        setVisible(false);
    };

    // const handleUserInfo = (userData) => {
    //     // داده‌های دریافتی از کامپوننت فرزند
    //     console.log("User Info: ", userData);
    //     setUserData(userData); // ذخیره داده‌ها در state
    // }





    const dispatch = useDispatch();
    const [provinceList, setProvinceList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [settings, setSettings] = useState(null);
    const toast = useRef(null);
    const [validated, setValidated] = useState(false);
    const userPaymentInfo = useSelector(state => state.userPaymentInfo);


    // Receiver info
    const [province, setProvince] = useState('');
    const [city, setCity] = useState('');
    const [receiverName, setReceiverName] = useState('');
    const [address, setAddress] = useState('');
    const [plate, setPlate] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [unit, setUnit] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [visibleProvince, setVisibleProvince] = useState(false);
    const [visibleCity, setVisibleCity] = useState(false);
    const [items, setItems] = useState([]);



    const { showError, showSuccess } = useToastNotification();

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.removeProperty("overflow");
        };
    }, []); 

    const getCities = async (selectedProvince) => {
        try {
            const res = await getCity(selectedProvince); // Assume getCity can take province as argument
            setCityList(res.data.data);
        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }

    };

    const getProvinces = async () => {
        // setLoading(true);
        try {
            const res = await getProvince();
            setProvinceList(res.data.data);
            setLoading(false);

        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            setLoading(false);

        }

    };

    useEffect(() => {
        getProvinces();
        setTimeout(() => {
            const productData = sessionStorage.getItem('cartItems');
            if (productData) {
                setItems(JSON.parse(productData));
            }
            setSettings(JSON.parse(localStorage.getItem('settings')));
            setLocalPaymentData();

        }, 1000);
    }, []);

    const setLocalPaymentData = () => {
        setAddress(item.receiverAddress);
        setReceiverName(item.receiverName);
        // setDescription(item.receiverName);
        setMobile(parseInt(item.receiverPhone));
        setProvince(parseInt(item.provinceId));
        setCity(parseInt(item.cityId));
        setPlate(parseInt(item.plateNumber));
        setUnit(parseInt(item.unitNumber));
        setPostalCode(parseInt(item.receiverPotstalCode));
    };

    const formRef = useRef(null);

    useEffect(() => {
        if (province) {
            if (typeof province === 'object' && Object.keys(province).length > 0) {

                getCities({ provinceId: province.id });
            } else {
                getCities({ provinceId: province });

            }
        }
    }, [province]); // Fetch cities when province changes
    const submitOrder = async (e) => {
        e.preventDefault();
    
        // بررسی کل فرم (حتی فیلدهای پنهان)
        if (formRef.current && !formRef.current.checkValidity()) {
            setValidated(true);
            setEditSection(1); // انتقال به تب ویرایش اطلاعات
            return;
        }
    
        try {
            setBtnLoading(true);
            let pay = {
                updateId: item.updateId,
                receiverName: receiverName,
                receiverAddress: address,
                receiverOstanID: typeof province === 'object' && Object.keys(province).length > 0 ? province.id : province,
                receiverShahrID: typeof city === 'object' && Object.keys(city).length > 0 ? city.id : city,
                receiverPhone: mobile.toString(),
                receiverCodePostal: postalCode.toString(),
                plateNumber: plate,
                unitNumber: unit,
                description: description,
                cards: [userData]
            };
            console.log(pay);
            let res = await UpdateCard(pay);
            if(res.data.isSuccess){
                showSuccess('ویرایش کارت با موفقیت انجام شد')
            }else{
                showError(res.data.message)
            }
            console.log(res.data.isSuccess);
        } catch (error) {
            console.error("Error updating card:", error);
        } finally {
            setBtnLoading(false);
        }
    };
    

    const handleUserCard = (userData) => {
        // داده‌های دریافتی از کامپوننت فرزند
        setUserData(userData); // ذخیره داده‌ها در state
    }
    const [selectedImage, setSelectedImage] = useState(null);

    const handleDesignCard = (designCardData,image) => {
        console.log(image)
        // داده‌های دریافتی از کامپوننت فرزند
        setUserData(designCardData); // ذخیره داده‌ها در state
        setSelectedImage(image)
    }

    const provinceTitle = useMemo(() => {
        try {
            if (province && provinceList) {
                return provinceList.find(item => item.id === province).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [province]);

    const cityTitle = useMemo(() => {
        try {
            if (city && provinceList) {
                return cityList.find(item => item.id === city).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [city]);

    return (
        <Dialog className="animation" header="ویرایش کارت" visible={visible} style={{ width: '90vw', height: '90vh' }} onHide={onCloseModal}>
            <div className='d-flex align-items-center justify-content-center gap-2 w-50 mx-auto mb-2'>
                <button className={`${editSection === 1 ? 'btn-primary' : 'btn-outline-primary'} btn flex-1 p-2`} onClick={() => setEditSection(1)}>ویرایش اطلاعات</button>
                <button className={`${editSection === 0 ? 'btn-primary' : 'btn-outline-primary'} btn flex-1 p-2`} onClick={() => setEditSection(0)}>ویرایش کارت</button>
            </div>

            <Form ref={formRef} noValidate validated={validated} onSubmit={(e) => submitOrder(e)} >
                {editSection === 0 ? (
                    !item?.isPeronal ? (
                        <ReadyCard productId={item?.productId} onUserInfoChange={handleUserCard} />
                    ) : (
                        <>
                            <DesignCard product={item} onUserDesignCardChange={handleDesignCard} selectedImage={selectedImage}/>
                        </>
                    )
                ) : (
                    <div className=' payment-body'>

                        <div className='row mt-3 gy-3 peyment-card'>
                            <div className='col-12'>
                                <div className="text-sm font-bold">
                                    <div className="flex gap-2 align-items-start flex-col-dir">
                                        <Form.Group controlId="firstName" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>نام گیرنده <span className='text-[red]'> * </span></Form.Label>
                                            <Form.Control type="text" required value={receiverName} onChange={(e) => setReceiverName(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا نام گیرنده را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="mobile" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>شماره تماس گیرنده<span className='text-[red]'> * </span></Form.Label>
                                            <Form.Control className='number' type="number" inputMode="numeric" required value={mobile} onChange={(e) => setMobile(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا شماره تماس را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="flex gap-2 align-items-start">

                                        <Form.Group controlId="province" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                                            <div className='mobile'>

                                                <div className='input-icon '>
                                                    <Form.Control value={provinceTitle}
                                                        placeholder='انتخاب استان'
                                                        onClick={(e) => {
                                                            e.preventDefault(); // جلوگیری از باز شدن لیست
                                                            setVisibleProvince(true); // نمایش Sidebar
                                                        }}
                                                        readOnly />
                                                    <img src={ArrowDown} alt="" />
                                                </div>
                                            </div>
                                            <Sidebar
                                                header="استان"
                                                visible={visibleProvince}
                                                position="bottom"
                                                onHide={() => setVisibleProvince(false)}
                                            >
                                                <div className="prepared-text-options">
                                                    {provinceList.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className={`prepared-text-item ${province === item.id ? 'selected' : ''}`}
                                                            onClick={() => {
                                                                setProvince(item.id);
                                                                isMobile === true && setVisibleProvince(false); // Close sidebar on selection
                                                            }}
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #eee',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            {item.title}
                                                        </div>
                                                    ))}
                                                </div>
                                            </Sidebar>
                                            <Form.Select required value={province} onChange={(e) => setProvince(e.target.value)} className="web">

                                                <option value="" hidden>انتخاب استان</option>
                                                {provinceList.map(item => (

                                                    <option key={item.id} value={item.id}>{item.title}</option>

                                                ))}


                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                لطفا استان را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="city" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                                            <div className='mobile'>
                                                <div className='input-icon '>
                                                    <Form.Control value={cityTitle}
                                                        placeholder='انتخاب شهر'
                                                        onClick={(e) => {
                                                            e.preventDefault(); // جلوگیری از باز شدن لیست
                                                            if (!!province) {
                                                                isMobile === true && setVisibleCity(true); // نمایش Sidebar
                                                            }
                                                        }}
                                                        readOnly />
                                                    <img src={ArrowDown} alt="" />
                                                </div>
                                            </div>
                                            <Sidebar
                                                header="شهر"
                                                visible={visibleCity}
                                                position="bottom"
                                                onHide={() => setVisibleCity(false)}
                                            >
                                                <div className="prepared-text-options">
                                                    {cityList.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className={`prepared-text-item ${city === item.id ? 'selected' : ''}`}
                                                            onClick={() => {
                                                                setCity(item.id);
                                                                setVisibleCity(false); // Close sidebar on selection
                                                            }}
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #eee',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            {item.title}
                                                        </div>
                                                    ))}
                                                </div>
                                            </Sidebar>
                                            <Form.Select className='web' required value={city} onChange={(e) => setCity(e.target.value)}
                                                disabled={!province}>
                                                <option value="" hidden>انتخاب شهر</option>
                                                {cityList.map(item => (
                                                    <option key={item.id} value={item.id}>{item.title}</option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                لطفا شهر را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="flex gap-2 align-items-start">
                                        <Form.Group controlId="address" className="mb-3 w-100 max-md:!w-full">
                                            <Form.Label>آدرس <span className='text-[red]'> * </span></Form.Label>
                                            <Form.Control type="text" className='number' required value={address} onChange={(e) => setAddress(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا آدرس را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="flex gap-2 align-items-start">
                                        <Form.Group controlId="plate" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>پلاک <span className='text-[red]'> * </span></Form.Label>
                                            <Form.Control className='number' type="number" inputMode="numeric" required value={plate} onChange={(e) => setPlate(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا پلاک را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="unit" className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>واحد <span className='text-[red]'> * </span></Form.Label>
                                            <Form.Control className='number' type="number" inputMode="numeric" required value={unit} onChange={(e) => setUnit(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا واحد را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="flex gap-2 align-items-start">
                                            <Form.Group className='mb-3 w-1/2 max-md:!w-full' controlId="postalCode">
                                            <Form.Label>
                                                کد پستی <span className='text-[red]'> * </span>
                                            </Form.Label>

                                            <Form.Control
                                                required
                                                className='number'
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={10}
                                                pattern="[0-9]{10}"
                                                value={postalCode}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    // فقط عدد و حداکثر 10 رقم
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        setPostalCode(value);
                                                    }
                                                }}
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                کد پستی باید دقیقا ۱۰ رقم باشد
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3 w-1/2 max-md:!w-full">
                                            <Form.Label>توضیحات</Form.Label>
                                            <Form.Control as="textarea" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
                                            <Form.Control.Feedback type="invalid">
                                                لطفا توضیحات  را وارد کنید
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* <button className='btn btn-primary mt-4 w-1/2 max-md:!w-full' type='submit'>ویرایش اطلاعات</button> */}


                            </div>

                        </div>
                    </div>
                    // <EditInfo item={detail} onUserInfoChange={handleUserInfo} />
                )}
                <div className='d-flex'>
                    {/* <div className='w-1/2 max-md:!w-full'></div> */}
                    <button className='btn btn-primary mt-4 w-1/2 max-md:!w-full mb-2' disabled={btnLoading} type='submit'>ثبت {btnLoading && <LoaderBtn/>}</button>
                </div>
            </Form>
        </Dialog>
    );
}

export default FastLogin;

